function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["index"];
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/** *****************************************************************************
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2021, 2025. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 ****************************************************************************** */
import React, { useState } from "react";
import { findKey, get, isEmpty } from "lodash";
import { Column, CopyButton, DataTable, FlexGrid, Modal, Row, TableSelectAll, TableSelectRow } from "@carbon/react";
import { Message } from "@console/cloud-pal-community/components/Basic";
import { DataTableHOC } from "@console/cloud-pal-community/components/Basic/DataTableExtenders";
import { PANEL_MODE_ADD, PANEL_MODE_EDIT, PROP_APPCONFIG, PROP_ENUM, PROP_INTEGRATION, PROP_SECURE, PROP_TEXT, PROP_TEXTAREA, PROP_TABLE_SORT_ACTIONS, PROP_TABLE_SORT_VALUE } from "./Constants";
import { initLocales } from "../../utils/locales";
import vaultUtil from "../../utils/vault-util";
import { idContext, i18nContext, servicesContext } from "./table-context";
import PropertyTableHeader from "./PropertyTableHeader";
import PropertyTableRowDisplayValue from "./PropertyTableRowDisplayValue";
import PropertyTableRowName from "./PropertyTableRowName";
import PropertyTableRowActions from "./PropertyTableRowActions";
import PropertySidePanel from "./Properties/PropertySidePanel";
import propertyUtils from "../../utils/property-util";
var TableContainer = DataTable.TableContainer,
  Table = DataTable.Table,
  TableHead = DataTable.TableHead,
  TableRow = DataTable.TableRow,
  TableBody = DataTable.TableBody,
  TableCell = DataTable.TableCell,
  TableHeader = DataTable.TableHeader;
var withFilters = DataTableHOC.withFilters;
var DataTableWithFilters = withFilters(DataTable);
function PropertyTable(_ref) {
  var accountContext = _ref.accountContext,
    bssAccount = _ref.bssAccount,
    columnHeadings = _ref.columnHeadings,
    emptyStateIcon = _ref.emptyStateIcon,
    emptyStateTitle = _ref.emptyStateTitle,
    emptyStateDescription = _ref.emptyStateDescription,
    enableAppConfig = _ref.enableAppConfig,
    envId = _ref.envId,
    filterPlaceholder = _ref.filterPlaceholder,
    handleChange = _ref.handleChange,
    hideSearch = _ref.hideSearch,
    i18nStrings = _ref.i18nStrings,
    id = _ref.id,
    isLoadingToolchainServices = _ref.isLoadingToolchainServices,
    lang = _ref.lang,
    nameIdPrefix = _ref.nameIdPrefix,
    persistentSearch = _ref.persistentSearch,
    properties = _ref.properties,
    readonly = _ref.readonly,
    showLock = _ref.showLock,
    showNotification = _ref.showNotification,
    size = _ref.size,
    tableHeader = _ref.tableHeader,
    toolchainId = _ref.toolchainId,
    toolchainServices = _ref.toolchainServices;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    showPropertyPanel = _useState2[0],
    setShowPropertyPanel = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    editingProperty = _useState4[0],
    setEditingProperty = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    propertyPanelError = _useState6[0],
    setPropertyPanelError = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    deleteModalProperties = _useState8[0],
    setDeleteModalProperties = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showDiscardModal = _useState0[0],
    setShowDiscardModal = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    isFiltered = _useState10[0],
    setIsFiltered = _useState10[1];
  var i18n = initLocales(lang, i18nStrings);
  var propertyTypeLabels = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, PROP_ENUM, i18n.messages.propertyEnumLabel), PROP_INTEGRATION, i18n.messages.propertyIntegrationLabel), PROP_SECURE, i18n.messages.propertySecureLabel), PROP_TEXT, i18n.messages.propertyTextLabel), PROP_TEXTAREA, i18n.messages.propertyTextLabel), PROP_APPCONFIG, i18n.messages.propertyAppConfigLabel);
  var editProperty = function editProperty(index, property) {
    setEditingProperty(_objectSpread(_objectSpread({}, property), {}, {
      index: index
    }));
    setShowPropertyPanel(PANEL_MODE_EDIT);
  };
  var getRowActions = function getRowActions(rowIndex, property) {
    if (readonly) {
      return null;
    }
    return /*#__PURE__*/React.createElement(PropertyTableRowActions, {
      editProperty: editProperty,
      onConfirmDelete: function onConfirmDelete() {
        var newProperties = _toConsumableArray(properties);
        newProperties.splice(rowIndex, 1);
        return handleChange(newProperties);
      },
      rowIndex: rowIndex,
      property: property
    });
  };
  var getRowCopy = function getRowCopy(property) {
    var _property$type;
    var propertyType = (_property$type = property.type) === null || _property$type === void 0 ? void 0 : _property$type.toUpperCase();
    var copyValue = property.value || "";
    switch (propertyType) {
      case PROP_SECURE:
        if (!vaultUtil.parseValue(property.value)) {
          // Not a reference so no copy button
          return null;
        }
        break;
      case PROP_INTEGRATION:
        copyValue = propertyUtils.getIntegrationPropertyDisplayValue({
          i18n: i18n,
          property: property,
          toolchainServices: toolchainServices
        });
        break;
      case PROP_ENUM:
        var selectedItem = Object.keys(property.value || []).find(function (item) {
          return property.value[item];
        });
        copyValue = selectedItem || "";
        break;
      case PROP_APPCONFIG:
        // No copy button for AppConfig properties
        return null;
      default:
        // By default show the copyButton below using copyValue as the clipboard content
        break;
    }
    return /*#__PURE__*/React.createElement(CopyButton, {
      feedback: i18n.messages.copied,
      iconDescription: i18n.messages.copyToClipboard,
      onClick: function onClick() {
        return navigator.clipboard.writeText(copyValue);
      }
    });
  };
  var getRowsData = function getRowsData(propertiesData) {
    var rowsData = [];
    if (!isEmpty(propertiesData)) {
      propertiesData.forEach(function (item, index) {
        var property = item;
        var nameField = /*#__PURE__*/React.createElement(PropertyTableRowName, {
          id: "".concat(nameIdPrefix || "", "property-name-").concat(index),
          property: property
        });
        var valueField = /*#__PURE__*/React.createElement(PropertyTableRowDisplayValue, {
          isLoadingToolchainServices: isLoadingToolchainServices,
          property: property,
          showNotification: showNotification,
          toolchainServices: toolchainServices
        });
        var propertyData = {
          actions: getRowActions(index, property),
          copy: getRowCopy(property),
          id: "".concat(property.name),
          name: nameField,
          value: valueField,
          propType: propertyTypeLabels[property.type && property.type.toUpperCase()]
        };
        rowsData.push(propertyData);
      });
    }
    return rowsData;
  };
  var getColumnHeadings = function getColumnHeadings() {
    if (columnHeadings) {
      return columnHeadings;
    }
    return [{
      header: i18n.messages.propertyName,
      key: "name"
    }, {
      header: i18n.messages.propertyValue,
      key: "value"
    }, {
      header: "",
      // No heading for copy column
      key: "copy"
    }, {
      header: i18n.messages.propertyType,
      key: "propType"
    }, {
      header: "",
      // No heading for actions column
      key: "actions"
    }];
  };

  // Table filtering algorithm
  var searchTable = function searchTable(_ref2) {
    var cellsById = _ref2.cellsById,
      headers = _ref2.headers,
      inputValue = _ref2.inputValue,
      rowIds = _ref2.rowIds;
    if (isEmpty(inputValue)) {
      setIsFiltered(false);
      return rowIds;
    }
    setIsFiltered(true);
    return rowIds.filter(function (rowId) {
      return headers.some(function (_ref3) {
        var key = _ref3.key;
        if (key === PROP_TABLE_SORT_ACTIONS) {
          return false;
        }
        var idString = "".concat(rowId, ":").concat(key);
        var cellData = cellsById[idString];
        var cellType = get(cellData, ["value", "props", "property", "type"], "");

        // For secure properties, ignore plain values & but filter against reference names
        if (key === PROP_TABLE_SORT_VALUE && cellType === PROP_SECURE) {
          var secureValue = get(cellData, ["value", "props", "property", "value"], {});
          var isSecretReference = vaultUtil.SECRET_REGEX.test(secureValue);
          if (isSecretReference) {
            return secureValue.toLowerCase().includes(inputValue.toLowerCase());
          }
          return false;
        }
        if (key === PROP_TABLE_SORT_VALUE && cellType === PROP_ENUM) {
          // For single-select property, extract selected value
          var enumValue = get(cellData, ["value", "props", "property", key], {});
          var enumSelection = findKey(enumValue, function (entryKey) {
            return entryKey;
          }) || "";
          return enumSelection.toLowerCase().includes(inputValue.toLowerCase());
        }
        if (key === PROP_TABLE_SORT_VALUE && cellType === PROP_INTEGRATION) {
          var property = get(cellData, ["value", "props", "property"], {});
          var displayValue = propertyUtils.getIntegrationPropertyDisplayValue({
            i18n: i18n,
            property: property,
            toolchainServices: toolchainServices
          });
          return displayValue.toLowerCase().includes(inputValue.toLowerCase());
        }

        // Extract the property name or value
        var cellValue = cellData.value;
        if (cellValue instanceof Object) {
          cellValue = get(cellData, ["value", "props", "property", key], "");
        }
        if (!cellValue) {
          return false;
        }
        return cellValue.toLowerCase().includes(inputValue.toLowerCase());
      });
    });
  };
  var renderTable = function renderTable(_ref4) {
    var getBatchActionProps = _ref4.getBatchActionProps,
      getHeaderProps = _ref4.getHeaderProps,
      getSelectionProps = _ref4.getSelectionProps,
      getTableContainerProps = _ref4.getTableContainerProps,
      getTableProps = _ref4.getTableProps,
      headers = _ref4.headers,
      onInputChange = _ref4.onInputChange,
      rows = _ref4.rows,
      selectedRows = _ref4.selectedRows;
    var emptyIcon = emptyStateIcon || "EMPTY";
    var emptyTitle = emptyStateTitle || i18n.messages.emptyPropertiesTableTitle;
    var emptyDescription = emptyStateDescription || i18n.messages.emptyPropertiesTableDescription;
    if (isFiltered && rows.length === 0) {
      emptyDescription = i18n.messages.emptyPropertiesTableFilteredDescription;
      emptyIcon = emptyStateIcon || "NORESULTS";
    }
    var tableContainerClass = "";
    if (hideSearch) {
      tableContainerClass = "ocr--property-table-hide-search";
    } else {
      tableContainerClass = "cds--table-with-filters";
    }
    return /*#__PURE__*/React.createElement(i18nContext.Provider, {
      value: i18n
    }, /*#__PURE__*/React.createElement(servicesContext.Provider, {
      value: toolchainServices
    }, /*#__PURE__*/React.createElement(TableContainer, _extends({
      className: tableContainerClass
    }, getTableContainerProps()), tableHeader || /*#__PURE__*/React.createElement(PropertyTableHeader, {
      addProperty: function addProperty(type) {
        setEditingProperty({
          type: type
        });
        setShowPropertyPanel(PANEL_MODE_ADD);
      },
      enableAppConfig: enableAppConfig,
      filterPlaceholder: filterPlaceholder,
      getBatchActionProps: getBatchActionProps,
      handleDelete: function handleDelete(selectedPropertyRows, cancelSelection) {
        var selectedProperties = selectedPropertyRows.map(function (_ref5) {
          var id = _ref5.id;
          return id;
        });
        setDeleteModalProperties({
          cancelSelection: cancelSelection,
          selectedProperties: selectedProperties
        });
      },
      hideSearch: hideSearch,
      onInputChange: onInputChange,
      persistentSearch: persistentSearch,
      readonly: readonly,
      selectedRows: selectedRows
    }), /*#__PURE__*/React.createElement(Table, getTableProps(), /*#__PURE__*/React.createElement(TableHead, null, /*#__PURE__*/React.createElement(TableRow, null, !readonly && /*#__PURE__*/React.createElement(TableSelectAll, getSelectionProps()), headers.map(function (header) {
      return /*#__PURE__*/React.createElement(TableHeader, _extends({
        key: header.key
      }, getHeaderProps({
        header: header
      })), header.header);
    }))), /*#__PURE__*/React.createElement(TableBody, null, rows.length === 0 && /*#__PURE__*/React.createElement(TableRow, {
      className: "ocr--property-table__no-hover"
    }, /*#__PURE__*/React.createElement(TableCell, {
      colSpan: readonly ? headers.length : headers.length + 1
    }, /*#__PURE__*/React.createElement(FlexGrid, {
      className: "ocr--property-table__empty-state"
    }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Column, {
      sm: 4,
      lg: {
        offset: 1,
        span: 15
      },
      className: "ocr--property-table__empty-state-col"
    }, /*#__PURE__*/React.createElement(Message, {
      caption: emptyDescription,
      icon: emptyIcon,
      text: emptyTitle
    })))))), rows.length > 0 && rows.map(function (row) {
      return /*#__PURE__*/React.createElement(TableRow, {
        key: row.id
      }, !readonly && /*#__PURE__*/React.createElement(TableSelectRow, getSelectionProps({
        row: row
      })), row.cells.map(function (cell) {
        return /*#__PURE__*/React.createElement(TableCell, {
          className: "cell-".concat(cell.info.header),
          key: cell.id
        }, cell.value);
      }));
    }))))));
  };
  var dataTableProps = _objectSpread({
    filterRows: searchTable,
    // TODO allow this function to be passed in as a prop?
    headers: getColumnHeadings(),
    isSortable: false,
    // TODO allow this to be set by passed in prop?
    render: renderTable,
    rows: getRowsData(properties)
  }, size ? {
    size: size
  } : undefined);
  var handleClose = function handleClose() {
    setShowPropertyPanel(null);
    setEditingProperty(null);
    setPropertyPanelError(null);
  };
  return /*#__PURE__*/React.createElement(i18nContext.Provider, {
    value: i18n
  }, /*#__PURE__*/React.createElement(servicesContext.Provider, {
    value: toolchainServices
  }, /*#__PURE__*/React.createElement(idContext.Provider, {
    value: {
      accountContext: accountContext,
      bssAccount: bssAccount,
      envId: envId,
      toolchainId: toolchainId
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ocr--property-table",
    id: id
  }, /*#__PURE__*/React.createElement(DataTableWithFilters, dataTableProps), showPropertyPanel ? /*#__PURE__*/React.createElement(PropertySidePanel, {
    error: propertyPanelError,
    handleClose: handleClose,
    handleChange: (/*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(editedProperty) {
        var newProperties, index, property, error;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              newProperties = properties ? _toConsumableArray(properties) : [];
              index = editedProperty.index, property = _objectWithoutProperties(editedProperty, _excluded);
              if (typeof index === "undefined") {
                newProperties.push(property);
              } else {
                newProperties[index] = property;
              }
              _context.next = 5;
              return handleChange(newProperties);
            case 5:
              error = _context.sent;
              if (error) {
                setPropertyPanelError(error);
              } else {
                handleClose();
              }
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref6.apply(this, arguments);
      };
    }()),
    isLoadingToolchainServices: isLoadingToolchainServices,
    lang: lang,
    mode: showPropertyPanel,
    onCloseErrorNotification: function onCloseErrorNotification() {
      setPropertyPanelError(null);
    },
    property: editingProperty,
    propNames: propertyUtils.getAllPropNames(properties),
    showDiscardModal: setShowDiscardModal,
    showLock: showLock
  }) : null, deleteModalProperties ? /*#__PURE__*/React.createElement(Modal, {
    open: true,
    modalHeading: i18n.messages.modalDeleteBatchTitle,
    primaryButtonText: i18n.messages["delete"],
    secondaryButtonText: i18n.messages.cancel,
    onRequestClose: function onRequestClose() {
      return setDeleteModalProperties(null);
    },
    onRequestSubmit: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var newProperties, error;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            newProperties = properties.filter(function (property) {
              return !deleteModalProperties.selectedProperties.includes(property.name);
            });
            _context2.next = 3;
            return handleChange(newProperties);
          case 3:
            error = _context2.sent;
            if (!error) {
              deleteModalProperties.cancelSelection();
            }
            setDeleteModalProperties(null);
          case 6:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })),
    onSecondarySubmit: function onSecondarySubmit() {
      return setDeleteModalProperties(null);
    },
    danger: true
  }, i18n.messages.modalDeleteBatchConfirm) : null, showDiscardModal ? /*#__PURE__*/React.createElement(Modal, {
    open: true,
    modalHeading: i18n.messages.modalCancelConfirmTitle,
    primaryButtonText: i18n.messages.discard,
    secondaryButtonText: i18n.messages.cancel,
    onRequestClose: function onRequestClose() {
      return setShowDiscardModal(false);
    },
    onRequestSubmit: function onRequestSubmit() {
      setShowDiscardModal(false);
      handleClose();
    },
    onSecondarySubmit: function onSecondarySubmit() {
      return setShowDiscardModal(false);
    },
    danger: true
  }, i18n.messages.modalCancelConfirm) : null))));
}
export default PropertyTable;